module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "chat-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "chat-form_message"
  }, [_vm._v("На одинаковые вопросы будут одинаковые ответы\n")]), _c('img', {
    staticClass: "chat-form_icon-pen",
    attrs: {
      "src": require("@/assets/pen.svg")
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "chat-form_input",
    attrs: {
      "name": "q",
      "type": "text",
      "placeholder": "Введите вопрос",
      "autocomplete": "off",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "chat-form_button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabledButton
    }
  }, [_vm._v("Узнать ответ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2379192c"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-form.vue
// module id = 95
// module chunks = 1